import store from "@/store";
import { InspectKbn, SeibiKbn } from "@/model/InspectKbn";
import { InspectStaff } from "@/model/InspectStaff";
import { LiftUse } from "@/model/LiftUse";
import { InspectDetail } from "@/model/InspectDetail";
import { InspectionDetailState } from "@/store/modules/inspectionDetailStore";

const namespace = "InspectionDetail";

export class InspectionStaffHojoDetailStoreService {
  deSelHojo: boolean = false;

  // サービス初期化時に補助整備士の選択管理枠をStoreへ登録する
  constructor() {
    this.addNowSelected();
  }

  // InspectionDetail Store全体の現在状態を参照する
  get currentState(): InspectionDetailState {
    return store.getters[`${namespace}/currentState`];
  }

  // 補助整備士が選択済みかどうかを参照する
  get nowSelected(): boolean {
    const nowSelected = store.getters[`${namespace}/getNowSelected`];
    if (nowSelected.staffHojo === true || nowSelected.staffHojo === false) {
      return nowSelected.staffHojo;
    }
    this.addNowSelected();
    return false;
  }

  // 補助整備士一覧の選択済みデータを参照する
  get staffHojo(): InspectStaff[] {
    return store.getters[`${namespace}/getStaffHojo`];
  }

  // 整備士一覧の選択済みデータを参照する
  get staffSeibishi(): InspectStaff[] {
    return store.getters[`${namespace}/getStaffSeibishi`];
  }

  // 整備士と補助整備士の合計選択上限値を参照する
  get maxSeibishiHojoStaffCount(): number {
    return store.getters[`${namespace}/effectiveMaxSeibishiHojoStaffCount`];
  }

  // 補助整備士の選択管理枠をStoreへ追加する
  addNowSelected() {
    return store.dispatch(`${namespace}/addNowSelected`, "staffHojo");
  }

  // 補助整備士の選択済み状態をStoreへ反映する
  setNowSelected(payload: boolean) {
    return store.dispatch(`${namespace}/setNowSelected`, {
      key: "staffHojo",
      value: payload
    });
  }

  // 補助整備士の選択状態からスタート可否判定用の状態を更新する
  checkDisableStart(arrData: any, isUnSelect?: boolean) {
    let checked: boolean = false;
    if (isUnSelect) {
      checked = true;
    } else if (arrData) {
      checked = arrData.some((data: any) => data.selected == "1");
    }
    this.setNowSelected(checked);
  }

  // 補助整備士一覧をStoreへ反映する
  setStaffHojo(payload: InspectStaff[]) {
    return store.dispatch(`${namespace}/setStaffHojo`, payload);
  }

  // 共通処理から扱う補助整備士一覧を返す
  get list(): InspectStaff[] {
    return this.currentState.staffHojo;
  }

  // スタート時に保存対象にする補助整備士一覧を返す
  get selectedList(): InspectStaff[] {
    return this.staffHojo;
  }

  // 共通処理から補助整備士一覧をStoreへ反映する
  setList(payload: InspectStaff[]) {
    return this.setStaffHojo(payload);
  }

  // テンプレート表示用の補助整備士選択肢リストを生成する
  getTargetList() {
    return this.list.map((data: any) => {
      return {
        "mode": 1,
        "btnDel": false,
        "btnSel": data.selected == '1',
        "btnFre": data.selected == '0',
        "btnUse": data.inProgress == '1',
        "key": data.staffCd,
        "dataSet": data.staffCd,
        "isDisabled": false,
        "icon": "icon-engineer",
        "label": data.staffNm,
        "labelEntends1": null,
        "labelEntends2": null,
        "labelEntends3": null,
      };
    });
  }

  // スタート時に選択中の補助整備士を保存データへ反映する
  setStartInspectDetail(inspectionDetail: InspectDetail) {
    inspectionDetail.hojoSeibishi = [];
    this.selectedList.filter((data: InspectStaff) => {
      if (data.selected == "1") {
        inspectionDetail.hojoSeibishi.push({
          staffCd: data.staffCd,
          staffNm: data.staffNm
        });
      }
    });
  }

  // 取得済みの検査構成から補助整備士の初期選択情報を反映する
  applyInitialInspectionDetail(data: any, inspectionDetail?: InspectDetail) {
    // ダミー
    return { data, inspectionDetail };
  }

  // 補助整備士追加時に整備士・補助整備士の合計上限を超えないか判定する
  checkValidCountSeibishiHojo() {
    const seibishi = this.staffSeibishi.filter(data => data.selected == "1").length;
    const hojo = this.list.filter(data => data.selected == "1").length;
    return seibishi + hojo < this.maxSeibishiHojoStaffCount;
  }

  // 補助整備士の選択クリックを処理する
  select(code: string, confirm: boolean = false) {
    const staffHojo = this.list;
    let inprogressStaff: InspectStaff | null = null;
    staffHojo.map(data => {
      if (data.staffCd == code) {
        if (data.selected == "1") {
          data.selected = "0";
        } else {
          if (this.checkValidCountSeibishiHojo()) {
            if (data.inProgress == 1 && !confirm) {
              inprogressStaff = data;
            }
            this.deSelHojo = false;
            data.selected = "1";
          }
        }
      }
    });
    this.setList([...staffHojo]);
    this.checkDisableStart(staffHojo, this.deSelHojo);
    return { deSelHojo: this.deSelHojo, inprogressStaff };
  }

  // 補助整備士の「選択無し」状態を切り替える
  deSelect() {
    const staffHojo = this.list;
    if (!this.deSelHojo) {
      staffHojo.map(data => (data.selected = "0"));
    }
    this.deSelHojo = !this.deSelHojo;
    this.setList([...staffHojo]);
    this.checkDisableStart(staffHojo, this.deSelHojo);
    return this.deSelHojo;
  }

  // 補助整備士で「選択無し」を表示できるか返す
  canDeSelect() {
    return true;
  }

  // 補助整備士が「選択無し」状態か返す
  isDeSelected() {
    return this.deSelHojo;
  }

  // 共通呼び出し用の「選択無し」クリック処理
  clickDeSelect() {
    return this.deSelect();
  }

  // Storeに既存リストがある場合に選択状態を再評価する
  applyExistingList() {
    const staffHojo = this.list;
    if (this.selectedList.length == 0) {
      this.deSelHojo = true;
    }
    this.checkDisableStart(staffHojo, this.deSelHojo);
    return {
      staffHojo,
      deSelHojo: this.deSelHojo
    };
  }

  // API取得結果から補助整備士一覧の初期選択状態を作成する
  setInitialList(res: InspectStaff[], selectedStaff: any[] | undefined, isDeSelStaff: boolean) {
    const staffHojo = res.map(data => {
      let selected = "0";
      if (selectedStaff) {
        if (selectedStaff.findIndex(hojoSeibishi => data.staffCd == hojoSeibishi.staffCd) > -1) {
          selected = "1";
          this.setNowSelected(true);
        }
      }
      return { ...data, selected };
    });
    this.deSelHojo = false;
    if ((!selectedStaff || selectedStaff.length === 0) && isDeSelStaff) {
      this.setNowSelected(true);
      this.deSelHojo = true;
    }
    this.setList(staffHojo);
    return {
      staffHojo,
      deSelHojo: this.deSelHojo
    };
  }

  // 補助整備士一覧を既存StoreまたはAPIから取得する
  getDataList(
    loadInitialList: () => Promise<InspectStaff[]>,
    selectedStaff: any[] | undefined,
    isDeSelStaff: boolean
  ) {
    if (this.list.length > 0) {
      this.applyExistingList();
      return {
        hasExistingList: true,
        promise: null
      };
    }
    return {
      hasExistingList: false,
      promise: loadInitialList().then((res: InspectStaff[]) => {
        return this.setInitialList(res, selectedStaff, isDeSelStaff);
      })
    };
  }
}
